import { ListSortDirection, Sort } from "../../models/api/sort";
import { ClientInvoiceDTO, ClientInvoiceSTO } from "../../models/legal-entity-clients/client-invoices";
import { BaseApiService } from "../base/base-api.service";

export class ClientInvoicesApiService extends BaseApiService<ClientInvoiceDTO, ClientInvoiceSTO> {
  constructor() {
    super({
      servicePath: "/ClientInvoices",
      loadItemsPath: "/GetClientInvoices",
      saveItemsPath: "/SaveClientInvoices",
    });
    this.defaultSort = [
      {
        name: "client.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
